import { deleteCookie, getCookie } from "./cookies";

const cookieKey = "GTLogin"
const tokenKey = "dttoken"

export function getAuthToken() : string | null {
   let token: string | null = null;

   const guidPattern = /GUID=([0-9A-Z]+)/;
   const loginCookie = getCookie(cookieKey);

   if (loginCookie) {
      const guidMatches = guidPattern.exec(loginCookie);

      if (guidMatches) {
         token = guidMatches[1];
      }
   }

   if (!token) {
      // check for a temporary cookie used to transfer auth from rest of server-side web app
      const tempCookie = getCookie(cookieKey + '_temp');

      if (tempCookie) {
         const guidMatches = guidPattern.exec(tempCookie);

         if (guidMatches) {
            token = guidMatches[1];

            // If temp cookie found, transfer to local storage and remove temp cookie
            saveAuthToken(token);
         }
         deleteCookie(cookieKey + '_temp');
      }
      
      if (!token) {
         // Check new location for auth token
         token = window.localStorage.getItem(tokenKey);
      }

      if (!token) {
         // Auto redirect with no auth token.
         // If/when whole of Group Trips is rewritten in Vue, this should be replaced with router.beforeEach 
         window.location.href = "/cms/login?r=" + encodeURIComponent(window.location.pathname);
      }
   }

   return token;
}

export function saveAuthToken(token: string) {
   window.localStorage.setItem(tokenKey, token);
}

export function deleteAuthToken() {
   deleteCookie(cookieKey);
   window.localStorage.removeItem(tokenKey);
}